import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";
import { useTestimonials } from "@/lib/useTestimonials";

export default function ReviewHighlight() {
    const items = useTestimonials();
    const [i, setI] = useState(0);

    useEffect(() => {
        if (items.length < 2) return;
        const t = setInterval(() => setI((n) => (n + 1) % items.length), 5000);
        return () => clearInterval(t);
    }, [items.length]);

    if (items.length === 0) return null;
    const r = items[i % items.length];

    return (
        <div className="mt-6 overflow-hidden rounded-2xl border border-border bg-background px-5 py-4" data-testid="quote-review-highlight">
            <AnimatePresence mode="wait">
                <motion.figure
                    key={r.id}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="flex items-center justify-between">
                        <span className="flex gap-0.5">
                            {[1, 2, 3, 4, 5].map((n) => (
                                <Star key={n} size={12} className={n <= r.rating ? "fill-primary text-primary" : "text-border"} />
                            ))}
                        </span>
                        <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Google review</span>
                    </div>
                    <blockquote className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground/85">“{r.text}”</blockquote>
                    <figcaption className="mt-2 text-xs font-semibold text-primary">— {r.author}</figcaption>
                </motion.figure>
            </AnimatePresence>
        </div>
    );
}
